"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidateButton = exports.ModalTitle = exports.OrderChoiceGroup = exports.Container = void 0;
const button_1 = require("@kawaui/button");
const radio_1 = require("@kawaui/radio");
const styled_components_1 = __importStar(require("styled-components"));
exports.Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  padding: ${({ theme }) => theme.space.s300} ${({ theme }) => theme.space.s200} ${({ theme }) => theme.space.s200};

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}) {
    width: 754px;
    padding: ${({ theme }) => theme.space.s600} ${({ theme }) => theme.space.s800};
  }
`;
exports.OrderChoiceGroup = (0, styled_components_1.default)(radio_1.RadioGroup) `
  width: 100%;
`;
exports.ModalTitle = styled_components_1.default.h2 `
  width: 100%;
  margin-bottom: ${({ theme }) => theme.space.s400};

  text-align: left;

  ${({ theme }) => (0, styled_components_1.css)(theme.typography.heading.small)}

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}) {
    margin-bottom: ${({ theme }) => theme.space.s700};

    text-align: center;

    ${({ theme }) => (0, styled_components_1.css)(theme.typography.heading.subheading)};
  }
`;
exports.ValidateButton = (0, styled_components_1.default)(button_1.Button) `
  width: 100%;
  margin-top: ${({ theme }) => theme.space.s400};

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}) {
    width: auto;
    margin-top: ${({ theme }) => theme.space.s700};
    margin-left: auto;
  }
`;
